import {
  ArrowLeft,
  FileText,
  ChevronRight,
  Clock,
  Calendar,
  ChevronLeft,
} from "lucide-react";
import Footer from "../../../ui/Footer/Footer";
import { Link, useParams, useNavigate } from "react-router-dom";
import {
  getArticleById,
  getCategoryBySlug,
  allArticles,
} from "./helpCenterData";
import styles from "../HelpCenter.module.css";
import artStyles from "./HelpArticlePage.module.css";

const HelpArticlePage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const article = getArticleById(id || "");

  if (!article) {
    return (
      <div className={styles.container}>
        <div className={styles.hero}>
          <div className={styles.heroInner}>
            <div className={styles.heroNav}>
              <Link to="/HelpCenter" className={styles.backLink}>
                <ArrowLeft size={16} /> Back to Help Center
              </Link>
            </div>
            <h1 className={styles.heroTitle}>Article Not Found</h1>
          </div>
        </div>
      </div>
    );
  }

  const category = getCategoryBySlug(article.categorySlug);
  const categoryArticles = category?.articles || [];
  const currentIndex = categoryArticles.findIndex((a) => a.id === article.id);
  const prevArticle =
    currentIndex > 0 ? categoryArticles[currentIndex - 1] : null;
  const nextArticle =
    currentIndex < categoryArticles.length - 1
      ? categoryArticles[currentIndex + 1]
      : null;

  // Related articles from same category (excluding current)
  const related = categoryArticles
    .filter((a) => a.id !== article.id)
    .slice(0, 4);

  return (
    <div className={styles.container}>
      <div className={styles.hero} style={{ padding: "2rem 2rem 1.75rem" }}>
        <div className={styles.heroInner}>
          <div className={styles.heroNav}>
            <Link to="/HelpCenter" className={styles.backLink}>
              <ArrowLeft size={16} /> Help Center
            </Link>
          </div>
          <h1 className={styles.heroTitle} style={{ fontSize: "1.75rem" }}>
            {article.title}
          </h1>
          <div className={artStyles.meta}>
            <span className={artStyles.metaItem}>
              <Clock size={14} /> {article.readTime} read
            </span>
            <span className={artStyles.metaItem}>
              <Calendar size={14} /> Updated {article.lastUpdated}
            </span>
            {/* <Link
              to={`/HelpCenter/category/${article.categorySlug}`}
              className={artStyles.metaCategory}
            >
              {article.category}
            </Link> */}
          </div>
        </div>
      </div>

      <div className={styles.tabBar}>
        <Link to="/contact" className={styles.tab}>
          Contact Us
        </Link>
        <Link to="/HelpCenter" className={`${styles.tab} ${styles.tabActive}`}>
          Help Center
        </Link>
        {/* <Link to="/issues" className={styles.tab}>
          Report an Issue
        </Link> */}
      </div>

      <div className={styles.mainContent}>
        <div className={artStyles.breadcrumb}>
          <Link to="/HelpCenter">Help Center</Link>
          <ChevronRight size={14} />
          <Link to={`/HelpCenter/category/${article.categorySlug}`}>
            {article.category}
          </Link>
          <ChevronRight size={14} />
          <span>{article.title}</span>
        </div>

        <div className={artStyles.layout}>
          {/* Sidebar */}
          <aside className={artStyles.sidebar}>
            <h3 className={artStyles.sidebarTitle}>In this category</h3>
            {categoryArticles.map((a) => (
              <Link
                key={a.id}
                to={`/HelpCenter/article/${a.id}`}
                className={`${artStyles.sidebarLink} ${a.id === article.id ? artStyles.sidebarLinkActive : ""}`}
              >
                <FileText size={13} />
                <span>{a.title}</span>
              </Link>
            ))}
          </aside>

          {/* Article content */}
          <article className={artStyles.articleBody}>
            <div
              className={artStyles.articleContent}
              dangerouslySetInnerHTML={{ __html: article.content }}
            />

            {/* Prev / Next */}
            <div className={artStyles.articleNav}>
              {prevArticle ? (
                <Link
                  to={`/HelpCenter/article/${prevArticle.id}`}
                  className={artStyles.navLink}
                >
                  <ChevronLeft size={16} />
                  <div>
                    <span className={artStyles.navLabel}>Previous</span>
                    <span className={artStyles.navTitle}>
                      {prevArticle.title}
                    </span>
                  </div>
                </Link>
              ) : (
                <div />
              )}
              {nextArticle ? (
                <Link
                  to={`/HelpCenter/article/${nextArticle.id}`}
                  className={`${artStyles.navLink} ${artStyles.navLinkNext}`}
                >
                  <div>
                    <span className={artStyles.navLabel}>Next</span>
                    <span className={artStyles.navTitle}>
                      {nextArticle.title}
                    </span>
                  </div>
                  <ChevronRight size={16} />
                </Link>
              ) : (
                <div />
              )}
            </div>

            {/* Related */}
            {related.length > 0 && (
              <div className={artStyles.related}>
                <h3>Related Articles</h3>
                <div className={artStyles.relatedGrid}>
                  {related.map((r) => (
                    <Link
                      key={r.id}
                      to={`/HelpCenter/article/${r.id}`}
                      className={artStyles.relatedCard}
                    >
                      <FileText size={14} />
                      <span>{r.title}</span>
                    </Link>
                  ))}
                </div>
              </div>
            )}
          </article>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default HelpArticlePage;
